import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function ReferenceCard({ title, small, src }) {
  return (
    <div
      className={classNames(
        Styles.mainContainer,
        { [Styles.mainContainerSmall]: small },
      )}
    >
      <div
        className={classNames(
          Styles.title,
          { [Styles.titleSmall]: small },
        )}
      >
        {title}
      </div>
      {!small && (
        <div className={Styles.content}>
          <img src={src} alt="" style={{ objectFit: 'contain', width: '100%', height: '100%' }} />
        </div>
      )}
    </div>
  );
}

ReferenceCard.propTypes = {
  title: PropTypes.string,
  small: PropTypes.bool,
  src: PropTypes.string,
};

ReferenceCard.defaultProps = {
  title: '',
  small: false,
  src: '',
};
